import { mutationOptions, useQueryClient } from '@tanstack/react-query';
import type { z } from 'zod';

import type { sessionChargeChangeFee } from '../model/session-charge.schemas';
import type { ChangeFeeInput } from '../model/session-charge.types';
import { sessionChargeApi } from './session-charge.api';
import { queryKeys } from './session-charge.queries';

export function useChangeFeeOptions() {
    const queryClient = useQueryClient();
    return mutationOptions({
        mutationFn: ({
            id,
            ...data
        }: ChangeFeeInput & Pick<z.input<typeof sessionChargeChangeFee.input>, 'id'>) =>
            sessionChargeApi.changeFee(id, data),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.all }),
    });
}
